$('.all_btns').click(function(e){
  // e.preventDefault();
  var target = $($(this).attr('href'));
  if(target.length){
    var scrollTo = target.offset().top;
    $('body, html').animate({scrollTop: scrollTo+'px'}, 800);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  document.querySelectorAll('.header__inline-menu details').forEach(function (details) {
    const summary = details.querySelector('summary');

    details.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;

      document.querySelectorAll('.header__inline-menu details[open]').forEach(function (item) {
        if (item !== details) {
          item.removeAttribute('open');
          const itemSummary = item.querySelector('summary');
          if (itemSummary) itemSummary.setAttribute('aria-expanded', 'false');
        }
      });

      details.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    });

    details.addEventListener('mouseleave', function () {
      if (!isDesktop()) return;

      details.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });

    /* Click preventDefault removed so parent link works */
  });
});